import { defineMessages } from 'react-intl';

const messages = defineMessages({
  warehouseId: {
    description: 'editPreset PresetOptionLabel ship from',
    defaultMessage: 'Ship From',
    id: '5ZUTql',
  },
  shippingService: {
    description: 'editPreset PresetOptionLabel shipping service',
    defaultMessage: 'Shipping Service',
    id: 'XGCNYU',
  },
  packageTypeId: {
    description: 'editPreset PresetOptionLabel Package',
    defaultMessage: 'Package',
    id: 'jcyg2j',
  },
  confirmationId: {
    description: 'editPreset PresetOptionLabel confirmation',
    defaultMessage: 'Confirmation',
    id: 'aBNRN1',
  },
  insuranceProviderId: {
    description: 'editPreset PresetOptionLabel insurance',
    defaultMessage: 'Insurance',
    id: 'CJcdPw',
  },
  weight: {
    description: 'editPreset PresetOptionLabel weight',
    defaultMessage: 'Weight',
    id: 'kdeDzA',
  },
  dimensions: {
    description: 'editPreset PresetOptionLabel size',
    defaultMessage: 'Size',
    id: 'TdhKQO',
  },
  newPreset: {
    description: 'editPreset.newPresetText',
    defaultMessage: 'Create a preset to quickly apply shipping options. You can name it and assign it to a hotkey.',
    id: 'hK1UwD',
  },
  name: {
    description: 'editPreset.name',
    defaultMessage: 'Preset Name',
    id: '9cJY+3',
  },
  hotkey: {
    description: 'editPreset.hotkey',
    defaultMessage: 'Hotkey',
    id: 'O4r2Fg',
  },
  addShippingOptions: {
    description: 'editPreset.addShippingOptions',
    defaultMessage: 'Add Shipping Options',
    id: 'puPnw7',
  },
  shippingOptions: {
    description: 'editPreset.shippingOptions',
    defaultMessage: 'Shipping Options',
    id: 'Y1VEva',
  },
  none: {
    description: 'editPreset.none',
    defaultMessage: 'None',
    id: 'jtNiIM',
  },
  addShippingOptionMessage: {
    description: 'editPreset.addShippingOptionMessage',
    defaultMessage: 'Add at least one shipping option.',
    id: 'md8cmF',
  },
  presetNameErrorMessage: {
    description: 'preset.presetNameErrorMessage',
    defaultMessage: 'Enter a preset name',
    id: '0j18Cs',
  },
  nameRequiredMessage: {
    description: 'inline message to show when the name field is not filled out',
    defaultMessage: 'Presets require a name',
    id: 'TmXfrh',
  },
  oneOrMoreRequired: {
    description: 'message to show when there are not selected, valid options.',
    defaultMessage: 'Please select at least one preset option',
    id: 'Wxk4Fr',
  },
  removeShippingOptionButtonAriaLabel: {
    defaultMessage: 'Remove shipping option',
    description: 'Label for button to remove shipping option from a list of options',
    id: 'dyUiqa',
  },
});

export default messages;
